import React, { useContext } from "react";
import { AppContext } from "../context";
import SafeImage from "./SafeImage";

const Navbar = () => {
  const { config, clientId } = useContext(AppContext);

  return (
    <div id="navbar" style={clientId === "client_876" ?{ backgroundColor: config["colors"]["nav"], boxShadow: "0 4px 4px 0px rgba(0, 0, 0, 0.3)"}:{backgroundColor: config["colors"]["nav"]}}>
      {config["logo"].length > 0 && <SafeImage style={["client_876"].includes(clientId) ? {marginLeft: "0", paddingLeft: "6%"} : {}} id={["liberty_dev"].includes(clientId) ? "libertyLogo" : "logo"} alt="" src={config["logo"]} fallback={null} />}
    </div>
  );
};

export default Navbar;
